export default __webpack_public_path__ + "static/media/i5.c3714a8e.jpg";